import React, { ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

const LocaleMessage = ({
  id,
  values = {},
  tagName = 'div',
}: {
  id: string;
  values: Record<string, unknown>;
  tagName: React.ElementType<any>;
}): React.ReactElement => (
  <FormattedMessage
    id={id}
    tagName={tagName}
    values={{
      b: (chunks: React.ReactNode) => <b>{chunks}</b>,
      strong: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
      p: (chunks: React.ReactNode) => <p>{chunks}</p>,
      ...values,
    }}
  />
);

export { LocaleMessage };
